import React, { useState } from 'react';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

if (pdfMake.vfs === undefined) {
  pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts.vfs;
}

// ===================== STATIC CONTENT ============================
const LOGO_TOZ_TACOS = 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/lptg5d49_logo%20toz%20tacocs%202.png';
// Tož Tacos food truck na přívěsu s VŠE PRO AKCI tažným vozem (hlavní koncept)
const FOTO_TRUCK_CONCEPT = 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/u2jqs1f5_Sni%CC%81mek%20obrazovky%202026-06-15%20v%C2%A010.00.14.png';
// Tož Tacos food truck v provozu s týmem a mexickou vlajkou
const FOTO_TRUCK_OPERATION = 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/5os2uj6g_Sni%CC%81mek%20obrazovky%202026-06-15%20v%C2%A09.00.59.png';
// Tož Tacos food truck — detail výdeje s týmem a mexickou vlajkou
const FOTO_TRUCK_DETAIL = 'https://customer-assets.emergentagent.com/job_vsepro-wanzl/artifacts/q7uwdee1_IMG_0596.JPG';

const META = {
  city: 'OTROKOVICE',
  tender: 'Výběrové řízení – sezónní mobilní občerstvení',
  location: 'Štěrkoviště, Otrokovice',
  season: 'Sezóna 2026 — 2027',
  client: 'Gourmet Crew s.r.o.',
  brand: 'Tož Tacos!',
  rent: '50 000 Kč',
  rentVat: 'za rok (0% sazba DPH)',
  deadline: 'Uzávěrka výběrového řízení: 15. 06. 2026 v 11:00 hod.',
  contactName: 'Dušan Horák',
  contactRole: 'Jednatel společnosti',
  contactPhone: '+420 602 551 551',
  contactEmail: '[doplnit e-mail]',
  contactAddress: 'J. Valčíka 1258, Kvítkovice, 765 02 Otrokovice',
  ico: '24409286',
  docCode: 'GC/2026/OTR-01',
};

const SECTIONS = [
  ['01', 'Úvodní slovo'],
  ['02', 'Představení Gourmet Crew s.r.o.'],
  ['03', 'Vize a koncept provozu'],
  ['04', 'Provozní doba a sezónnost'],
  ['05', 'Značka Tož Tacos! — propojení'],
  ['06', 'Food truck a vizuál'],
  ['07', 'Dřevěný mobiliář a posezení'],
  ['08', 'Sortiment a menu'],
  ['09', 'Dosavadní zkušenosti s hostinskou činností'],
  ['10', 'Řešení špiček — partnerství s Vše pro akci'],
  ['11', 'Platební možnosti'],
  ['12', 'Nabízené nájemné a shrnutí'],
  ['13', 'Čestné prohlášení uchazeče'],
  ['14', 'Přílohy a doklady'],
  ['15', 'Závěr a kontakt'],
];

const TYPICAL_MENU = [
  { name: 'Tacos al pastor', desc: 'Marinované vepřové, ananas, koriandr, červená cibule, salsa verde' },
  { name: 'Tacos de pollo', desc: 'Kuřecí prsa, limetková marináda, pico de gallo, smetanový dresink' },
  { name: 'Quesadilla classica', desc: 'Pšeničná tortilla, sýrová směs, guacamole, salsa, čerstvý salát' },
  { name: 'Burrito grande', desc: 'Hovězí / vegetariánské, fazole, rýže, sýr, salsa, jalapeños' },
  { name: 'Nachos s dipy', desc: 'Křupavé tortilla chipsy, guacamole, salsa roja, sýrový dip' },
  { name: 'Churros con chocolate', desc: 'Smažené sladké tyčinky se skořicovým cukrem a horkou čokoládou' },
];

const BEVERAGES = [
  'Mexická limonáda – limetka, máta, mango',
  'Coca-Cola / Fanta / Sprite (PET 0,5 l)',
  'Voda neperlivá / perlivá Mattoni',
  'Káva espresso, americano, latte',
  'Točené pivo (volitelně – po dohodě)',
  'Horký nápoj sezónně (čaj, čokoláda)',
];

// ===================== ON-PAGE UI ============================
const GourmetCrewOfferPage = () => {
  const [generating, setGenerating] = useState(false);

  const handleDownload = async () => {
    setGenerating(true);
    try {
      const doc = await buildPdf();
      pdfMake.createPdf(doc).download('Gourmet_Crew_Otrokovice_Sterkoviste_2026-2027.pdf');
    } finally {
      setTimeout(() => setGenerating(false), 1200);
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] text-stone-100" data-testid="gourmet-crew-page">
      {/* Hero */}
      <section className="relative overflow-hidden">
        {/* mexican color stripe */}
        <div className="absolute top-0 left-0 right-0 h-1 flex">
          <div className="flex-1 bg-[#006847]" />
          <div className="flex-1 bg-stone-100" />
          <div className="flex-1 bg-[#ce1126]" />
        </div>

        <div className="max-w-5xl mx-auto px-6 pt-20 pb-24">
          <div className="text-[10px] tracking-[0.4em] text-[#e6b800] mb-6">
            VÝBĚROVÉ ŘÍZENÍ · MĚSTO {META.city}
          </div>

          <h1 className="font-black leading-[0.95] text-5xl sm:text-6xl lg:text-7xl text-white">
            Sezónní mobilní<br />
            <span className="text-[#ce1126]">občerstvení</span> na<br />
            <span className="text-[#006847]">Štěrkovišti</span>
          </h1>

          <div className="mt-8 h-[3px] w-24 bg-[#e6b800]" />

          <p className="mt-8 text-stone-300 text-lg max-w-2xl leading-relaxed">
            Profesionální prezentační brožura společnosti{' '}
            <span className="text-white font-semibold">Gourmet Crew s.r.o.</span>{' '}
            ve spojení se značkou{' '}
            <span className="text-white font-semibold">Tož Tacos!</span> pro výběrové řízení města
            Otrokovice na provoz sezónního mobilního občerstvení na Štěrkovišti v sezónách
            2026 a 2027.
          </p>

          {/* meta strip */}
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-px bg-stone-800 border border-stone-800">
            <MetaCell label="Lokalita" value={META.location} />
            <MetaCell label="Sezóna" value={META.season} />
            <MetaCell label="Nabízené nájemné" value={`${META.rent} ${META.rentVat}`} accent />
            <MetaCell label="Brand" value={META.brand} />
          </div>

          {/* CTA */}
          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="download-pdf-btn"
              onClick={handleDownload}
              disabled={generating}
              className="group relative inline-flex items-center justify-center px-8 py-5 bg-[#ce1126] hover:bg-[#a50d1f] transition-colors text-white font-bold tracking-wide uppercase text-sm disabled:opacity-60"
            >
              <span className="absolute -top-px left-0 right-0 h-px bg-[#e6b800]" />
              {generating ? 'Generuji PDF brožuru…' : 'Stáhnout PDF brožuru'}
              <svg className="ml-3 w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M12 4v12m0 0l-5-5m5 5l5-5M5 21h14" strokeLinecap="square" />
              </svg>
            </button>
            <div className="flex items-center text-stone-400 text-sm">
              <span className="font-mono mr-3 text-[#e6b800]">{META.docCode}</span>
              <span>· {SECTIONS.length} sekcí · vícestránkový dokument</span>
            </div>
          </div>
        </div>

        {/* logo bottom right */}
        <div className="absolute bottom-8 right-8 hidden lg:block">
          <img src={LOGO_TOZ_TACOS} alt="Tož Tacos" className="h-24 opacity-90 bg-white p-2 rounded" />
        </div>
      </section>

      {/* Section overview list */}
      <section className="border-t border-stone-800">
        <div className="max-w-5xl mx-auto px-6 py-16">
          <div className="text-[10px] tracking-[0.4em] text-stone-500 mb-2">OBSAH BROŽURY</div>
          <h2 className="text-3xl font-bold text-white mb-10">Co dokument obsahuje</h2>
          <div className="grid sm:grid-cols-2 gap-x-12 gap-y-1">
            {SECTIONS.map(([num, title]) => (
              <div key={num} className="flex items-baseline py-3 border-b border-stone-800">
                <span className="font-mono text-[#e6b800] font-bold w-10">{num}</span>
                <span className="text-stone-200">{title}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact strip */}
      <section className="border-t border-stone-800 bg-[#080808]">
        <div className="max-w-5xl mx-auto px-6 py-12 flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <div className="text-[10px] tracking-[0.4em] text-[#e6b800]">KONTAKT</div>
            <div className="mt-2 text-2xl font-bold text-white">{META.contactName}</div>
            <div className="text-stone-400">{META.contactRole} · {META.client}</div>
          </div>
          <a href={`tel:${META.contactPhone.replace(/\s/g, '')}`} className="text-white text-xl font-mono tracking-wider hover:text-[#e6b800]">
            {META.contactPhone}
          </a>
        </div>
        {/* mexican color stripe */}
        <div className="h-1 flex">
          <div className="flex-1 bg-[#006847]" />
          <div className="flex-1 bg-stone-100" />
          <div className="flex-1 bg-[#ce1126]" />
        </div>
      </section>
    </div>
  );
};

const MetaCell = ({ label, value, accent }) => (
  <div className={`p-5 bg-[#0d0d0d] ${accent ? 'ring-1 ring-[#e6b800]/40' : ''}`}>
    <div className="text-[10px] tracking-[0.3em] text-stone-500">{label.toUpperCase()}</div>
    <div className={`mt-2 font-bold text-base ${accent ? 'text-[#e6b800]' : 'text-white'}`}>
      {value}
    </div>
  </div>
);

// ----- Image → dataURL helper (pdfMake needs base64) -----
const urlToDataUrl = async (url) => {
  try {
    const res = await fetch(url, { mode: 'cors' });
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = reject;
      r.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
};

// ============================================================
// =============== PDF BROCHURE GENERATOR =====================
// ============================================================
const buildPdf = async () => {
  // Pre-load images as base64
  const [logoDataUrl, truckConceptDataUrl, truckOperationDataUrl, truckDetailDataUrl] = await Promise.all([
    urlToDataUrl(LOGO_TOZ_TACOS),
    urlToDataUrl(FOTO_TRUCK_CONCEPT),
    urlToDataUrl(FOTO_TRUCK_OPERATION),
    urlToDataUrl(FOTO_TRUCK_DETAIL),
  ]);

  // ----------- Design tokens (Tož Tacos mexican palette) -----------
  const C = {
    ink: '#0d0d0d',          // primary background dark
    ink2: '#2b2b2b',         // body text dark
    muted: '#7a7a7a',
    paper: '#f7f3ea',        // cream
    paperAlt: '#efe8d8',
    hair: '#d8d2c2',
    white: '#ffffff',
    red: '#ce1126',          // mexican red
    green: '#006847',        // mexican green
    gold: '#e6b800',         // accent gold/cumin
    softCream: '#fbf8f2',
  };

  // ----------- helpers -----------
  const stripe = (w = 80) => ({
    table: {
      widths: [w / 3, w / 3, w / 3],
      body: [[
        { text: '', fillColor: C.green, border: [false, false, false, false] },
        { text: '', fillColor: C.white, border: [false, false, false, false] },
        { text: '', fillColor: C.red, border: [false, false, false, false] },
      ]],
      heights: [3],
    },
    layout: 'noBorders',
    margin: [0, 0, 0, 0],
  });

  const sectionHeader = (num, title, opts = {}) => ([
    ...(opts.pageBreak ? [{ text: '', pageBreak: 'before' }] : []),
    {
      table: {
        widths: ['auto', '*'],
        body: [[
          {
            text: num,
            fontSize: 40,
            bold: true,
            color: C.red,
            border: [false, false, false, false],
          },
          {
            stack: [
              { text: 'SEKCE', fontSize: 7, color: C.muted, characterSpacing: 3, margin: [0, 8, 0, 2] },
              { text: title, fontSize: 22, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
              { canvas: [{ type: 'rect', x: 0, y: 0, w: 44, h: 2.5, color: C.gold }] },
            ],
            border: [false, false, false, false],
            margin: [12, 0, 0, 0],
          },
        ]],
      },
      layout: 'noBorders',
      margin: [0, opts.first ? 0 : 8, 0, 18],
    },
  ]);

  const para = (text, opts = {}) => ({
    text,
    fontSize: opts.size || 10.5,
    color: opts.color || C.ink2,
    lineHeight: 1.55,
    alignment: opts.alignment || 'left',
    margin: opts.margin || [0, 0, 0, 8],
    bold: opts.bold,
    italics: opts.italics,
  });

  const bulletList = (items, color = C.red) => ({
    ul: items.map((t) => ({ text: t, fontSize: 10, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 3] })),
    color,
    margin: [0, 0, 0, 12],
  });

  const card = (heading, contentStack, accentColor = C.gold) => ({
    table: {
      widths: ['*'],
      body: [
        [{
          canvas: [{ type: 'rect', x: 0, y: 0, w: 240, h: 3, color: accentColor }],
          border: [false, false, false, false],
        }],
        [{
          stack: [
            { text: heading.toUpperCase(), fontSize: 8, color: accentColor === C.gold ? C.red : accentColor, characterSpacing: 1.8, bold: true, margin: [0, 8, 0, 6] },
            ...contentStack,
          ],
          fillColor: C.paper,
          border: [false, false, false, false],
          margin: [14, 0, 14, 14],
        }],
      ],
    },
    layout: 'noBorders',
  });

  const twoColCards = (cards) => {
    const rows = [];
    for (let i = 0; i < cards.length; i += 2) {
      rows.push([cards[i] || {}, cards[i + 1] || {}]);
    }
    return {
      table: { widths: ['*', '*'], body: rows },
      layout: { defaultBorder: false, paddingLeft: () => 0, paddingRight: (i) => (i === 0 ? 8 : 0), paddingTop: () => 0, paddingBottom: () => 10 },
      margin: [0, 0, 0, 4],
    };
  };

  const menuRow = (item, idx) => ({
    table: {
      widths: ['auto', '*'],
      body: [[
        { text: String(idx + 1).padStart(2, '0'), fontSize: 14, bold: true, color: C.red, border: [false, false, false, false], margin: [0, 6, 12, 0] },
        {
          stack: [
            { text: item.name, fontSize: 12, bold: true, color: C.ink, margin: [0, 5, 0, 2] },
            { text: item.desc, fontSize: 9.5, color: C.muted, lineHeight: 1.4, margin: [0, 0, 0, 6] },
          ],
          border: [false, false, false, true],
          borderColor: [C.hair, C.hair, C.hair, C.hair],
        },
      ]],
    },
    layout: {
      hLineWidth: (i, node) => (i === node.table.body.length ? 0.5 : 0),
      hLineColor: () => C.hair,
      vLineWidth: () => 0,
    },
    margin: [0, 0, 0, 4],
  });

  // ===================== DOCUMENT =====================
  return {
    pageSize: 'A4',
    pageMargins: [50, 55, 50, 65],

    // dark cover background
    background: (currentPage, pageSize) => {
      if (currentPage === 1) {
        return {
          canvas: [
            { type: 'rect', x: 0, y: 0, w: pageSize.width, h: pageSize.height, color: C.ink },
            // bottom black band
            { type: 'rect', x: 0, y: pageSize.height - 70, w: pageSize.width, h: 70, color: '#000000' },
            // mexican stripe at very bottom
            { type: 'rect', x: 0, y: pageSize.height - 6, w: pageSize.width / 3, h: 6, color: C.green },
            { type: 'rect', x: pageSize.width / 3, y: pageSize.height - 6, w: pageSize.width / 3, h: 6, color: C.white },
            { type: 'rect', x: (pageSize.width / 3) * 2, y: pageSize.height - 6, w: pageSize.width / 3, h: 6, color: C.red },
            // top gold accent
            { type: 'rect', x: 0, y: 0, w: 90, h: 3, color: C.gold },
          ],
        };
      }
      // soft cream-tinted decoration on inner pages – very subtle
      return null;
    },

    footer: (currentPage, pageCount) => {
      if (currentPage === 1) return null;
      return {
        table: {
          widths: ['*', 'auto'],
          body: [[
            {
              text: `${META.docCode}  ·  ${META.client}  ·  ${META.brand}  ·  Štěrkoviště ${META.season}`,
              fontSize: 7,
              color: C.muted,
              characterSpacing: 0.5,
              margin: [50, 16, 0, 0],
              border: [false, true, false, false],
              borderColor: [C.hair, C.hair, C.hair, C.hair],
            },
            {
              text: `${currentPage} / ${pageCount}`,
              fontSize: 8,
              bold: true,
              color: C.red,
              alignment: 'right',
              margin: [0, 16, 50, 0],
              border: [false, true, false, false],
              borderColor: [C.hair, C.hair, C.hair, C.hair],
            },
          ]],
        },
        layout: {
          hLineColor: () => C.hair,
          hLineWidth: (i) => (i === 0 ? 0.5 : 0),
          vLineWidth: () => 0,
        },
      };
    },

    content: [
      // ============================================================
      // ====================== COVER PAGE ==========================
      // ============================================================
      { text: '', margin: [0, 40, 0, 0] },
      { text: 'NABÍDKA DO VÝBĚROVÉHO ŘÍZENÍ', fontSize: 9, color: C.gold, characterSpacing: 4, margin: [0, 0, 0, 4] },
      { text: `MĚSTO ${META.city}`, fontSize: 9, color: C.muted, characterSpacing: 4, margin: [0, 0, 0, 60] },

      // big title
      { text: 'Sezónní mobilní', fontSize: 38, bold: true, color: C.white, lineHeight: 1.05 },
      { text: 'občerstvení', fontSize: 38, bold: true, color: C.red, lineHeight: 1.05 },
      { text: 'na Štěrkovišti', fontSize: 38, bold: true, color: C.green, lineHeight: 1.05, margin: [0, 0, 0, 14] },
      { canvas: [{ type: 'rect', x: 0, y: 0, w: 70, h: 3, color: C.gold }], margin: [0, 0, 0, 22] },
      { text: META.season, fontSize: 22, color: C.white, margin: [0, 0, 0, 4] },
      { text: 'Provoz pod značkou Tož Tacos!', fontSize: 11, color: '#cfc8b6', italics: true, margin: [0, 0, 0, 50] },

      // meta on cover (4 columns)
      {
        table: {
          widths: ['*', '*', '*', '*'],
          body: [[
            {
              stack: [
                { text: 'UCHAZEČ', fontSize: 7, color: C.gold, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: 'Gourmet', fontSize: 13, bold: true, color: C.white },
                { text: 'Crew s.r.o.', fontSize: 13, bold: true, color: C.white },
              ],
              border: [false, true, false, false],
              borderColor: ['#ffffff33', '#ffffff33', '#ffffff33', '#ffffff33'],
              margin: [0, 14, 8, 0],
            },
            {
              stack: [
                { text: 'LOKALITA', fontSize: 7, color: C.gold, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: 'Štěrkoviště', fontSize: 13, bold: true, color: C.white },
                { text: 'Otrokovice', fontSize: 11, color: '#cfc8b6', margin: [0, 1, 0, 0] },
              ],
              border: [false, true, false, false],
              borderColor: ['#ffffff33', '#ffffff33', '#ffffff33', '#ffffff33'],
              margin: [8, 14, 8, 0],
            },
            {
              stack: [
                { text: 'SEZÓNA', fontSize: 7, color: C.gold, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: '2026', fontSize: 13, bold: true, color: C.white },
                { text: '— 2027', fontSize: 13, bold: true, color: C.white },
              ],
              border: [false, true, false, false],
              borderColor: ['#ffffff33', '#ffffff33', '#ffffff33', '#ffffff33'],
              margin: [8, 14, 8, 0],
            },
            {
              stack: [
                { text: 'NÁJEMNÉ', fontSize: 7, color: C.gold, characterSpacing: 2, margin: [0, 0, 0, 4] },
                { text: `${META.rent}`, fontSize: 13, bold: true, color: C.white },
                { text: META.rentVat, fontSize: 10, color: '#cfc8b6' },
              ],
              border: [false, true, false, false],
              borderColor: ['#ffffff33', '#ffffff33', '#ffffff33', '#ffffff33'],
              margin: [8, 14, 0, 0],
            },
          ]],
        },
        layout: {
          hLineColor: () => '#ffffff33',
          hLineWidth: (i) => (i === 0 ? 0.6 : 0),
          vLineWidth: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },

      // cover bottom: brand & doc code
      { text: `DOKUMENT ${META.docCode}  ·  VERZE 1.0  ·  TOŽ TACOS!`, fontSize: 7, color: '#a8a297', characterSpacing: 2, margin: [0, 140, 0, 0] },

      // ============================================================
      // ====================== TABLE OF CONTENTS ===================
      // ============================================================
      { text: '', pageBreak: 'before' },
      { text: 'OBSAH', fontSize: 7, color: C.muted, characterSpacing: 3, margin: [0, 0, 0, 4] },
      { text: 'Struktura dokumentu', fontSize: 26, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
      { canvas: [{ type: 'rect', x: 0, y: 0, w: 50, h: 2.5, color: C.red }], margin: [0, 0, 0, 24] },
      {
        table: {
          widths: ['auto', '*'],
          body: SECTIONS.map(([n, t]) => [
            { text: n, fontSize: 16, bold: true, color: C.red, margin: [0, 8, 16, 6] },
            { text: t, fontSize: 12, color: C.ink, margin: [0, 12, 0, 6] },
          ]),
        },
        layout: {
          hLineWidth: () => 0.5,
          hLineColor: () => C.hair,
          vLineWidth: () => 0,
        },
      },
      { text: '', margin: [0, 30, 0, 0] },
      {
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: 'TOŽ TACOS! · MEXICKÁ KUCHYNĚ S ČESKÝM SRDCEM', fontSize: 8, color: C.red, bold: true, characterSpacing: 2, margin: [0, 0, 0, 4] },
              { text: '„Tacos · Quesadillas · Burritos"', fontSize: 14, italics: true, color: C.ink, margin: [0, 0, 0, 0] },
            ],
            fillColor: C.paper,
            border: [false, false, false, false],
            margin: [16, 14, 16, 14],
          }]],
        },
        layout: 'noBorders',
      },

      // ============================================================
      // ============ 01 — ÚVODNÍ SLOVO =============================
      // ============================================================
      ...sectionHeader('01', 'Úvodní slovo', { pageBreak: 'before', first: true }),
      para(
        'Vážení zástupci města Otrokovice,',
        { bold: true, color: C.ink, size: 11 }
      ),
      para(
        'předkládáme Vám nabídku společnosti Gourmet Crew s.r.o. do výběrového řízení na provoz sezónního mobilního občerstvení v rekreačním areálu Štěrkoviště pro sezóny 2026 a 2027. Naše společnost stojí za úspěšným gastronomickým konceptem Tož Tacos! — autentickou mexickou kuchyní servírovanou z profesionálně vybaveného food trucku.'
      ),
      para(
        'Cílem této nabídky je nejen splnit zadání výběrového řízení, ale především přinést na Štěrkoviště kvalitní stravovací službu, která významně zvýší atraktivitu lokality pro místní obyvatele i návštěvníky regionu. Spolupráce s naším partnerem — eventovou agenturou Vše pro akci s.r.o. — nám zároveň umožní bezpečně zvládnout i nárazové špičky během letních víkendů a kulturních akcí.'
      ),
      para(
        'V následujících kapitolách najdete podrobné představení společnosti, vize provozu, vybavení, kompletní sortiment, technické řešení i finanční nabídku.'
      ),

      // signature-ish line
      {
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: META.contactName, fontSize: 12, bold: true, color: C.ink, margin: [0, 0, 0, 2] },
              { text: `${META.contactRole}, ${META.client}`, fontSize: 9.5, color: C.muted },
              { text: META.contactPhone, fontSize: 10, color: C.red, bold: true, margin: [0, 4, 0, 0] },
            ],
            fillColor: C.paper,
            border: [false, true, false, false],
            borderColor: [C.gold, C.gold, C.gold, C.gold],
            margin: [16, 14, 16, 14],
          }]],
        },
        layout: {
          hLineWidth: () => 2.5,
          hLineColor: () => C.gold,
          vLineWidth: () => 0,
        },
        margin: [0, 12, 0, 0],
      },

      // ============================================================
      // ============ 02 — PŘEDSTAVENÍ GOURMET CREW =================
      // ============================================================
      ...sectionHeader('02', 'Představení Gourmet Crew s.r.o.', { pageBreak: 'before' }),
      para(
        'Gourmet Crew s.r.o. je česká společnost specializující se na provozování mobilního občerstvení a streetfoodových konceptů. Naším know-how je kombinace kvalitních surovin, autentických receptur a profesionálního servisu — a to vše v podobě, která je vhodná jak pro každodenní rekreační provoz, tak pro velké akce s tisíci návštěvníky.'
      ),
      para('Klíčové pilíře naší práce:', { bold: true, color: C.ink, size: 11 }),
      bulletList([
        'Profesionální tým provozovatele a kuchařů se zkušeností s mobilním gastroprovozem.',
        'Vlastní food truck s plnohodnotnou výbavou (gril, fritéza, chladicí zóna, výdej).',
        'Hygienické zázemí v souladu s normami HACCP a požadavky KHS.',
        'Striktní dodavatelský řetězec — čerstvé maso, zelenina a pekařské produkty od lokálních a ověřených dodavatelů.',
        'Schopnost škálovat — od běžného víkendového provozu po cateringové akce pro stovky hostů.',
      ]),
      para('Záruka kvality a hygieny:', { bold: true, color: C.ink, size: 11 }),
      para(
        'Veškerý provoz probíhá podle HACCP, s pravidelnou kontrolou teplot, evidencí surovin a školeným personálem. Disponujeme platnými povoleními k provozu mobilního občerstvení a sjednaným pojištěním odpovědnosti.'
      ),

      // ============================================================
      // ============ 03 — VIZE A KONCEPT ===========================
      // ============================================================
      ...sectionHeader('03', 'Vize a koncept provozu', { pageBreak: 'before' }),
      para(
        'Štěrkoviště je jedním z nejnavštěvovanějších rekreačních míst regionu — místem pro rodiny, sportovce i mladé lidi. Naší vizí je vytvořit zde stánek, který bude nejen kvalitním zdrojem rychlého občerstvení, ale stane se přirozenou součástí letní atmosféry této lokality.'
      ),

      twoColCards([
        card('KONCEPT', [
          { text: 'Mexický streetfood', fontSize: 12, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Tož Tacos! přináší autentickou mexickou kuchyni v moderním pojetí — rychlé, syté a poctivé jídlo, které si rádi dají všechny generace návštěvníků.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ]),
        card('ATMOSFÉRA', [
          { text: 'Letní pohoda', fontSize: 12, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Dřevěný mobiliář z masivu s opěradly, stoly se slunečníky, mexické vlajky a živá hudba ve výjimečných dnech. Místo, kde lidé rádi zůstanou.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.green),
        card('PROVOZ', [
          { text: 'Sezónní 7 dní v týdnu', fontSize: 12, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'V hlavní sezóně (květen — září) každý den, mimosezónně víkendy a akce. Provozní doba navržena podle špiček návštěvnosti.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.red),
        card('CENOVÁ POLITIKA', [
          { text: 'Dostupnost pro všechny', fontSize: 12, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Vyvážená cenová hladina, jasné ceníky, žádné skryté přirážky. Atraktivní nabídka pro rodiny i pro mladé.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.gold),
      ]),

      // ============================================================
      // ============ 04 — PROVOZNÍ DOBA A SEZÓNNOST ================
      // ============================================================
      ...sectionHeader('04', 'Provozní doba a sezónnost', { pageBreak: 'before' }),
      para(
        'Provoz mobilního občerstvení na Štěrkovišti je navržen tak, aby maximálně využíval návštěvnost rekreačního areálu a zároveň pružně reagoval na sezónní výkyvy a pořádané akce.'
      ),

      para('Plánovaná provozní doba', { bold: true, color: C.ink, size: 11 }),
      {
        table: {
          widths: ['30%', '*'],
          body: [
            [
              { text: 'Hlavní sezóna', fontSize: 10, bold: true, color: C.red, margin: [0, 6, 0, 6] },
              { text: '1. 5. — 30. 9.   ·   denně 10:00 — 22:00', fontSize: 10, color: C.ink2, margin: [0, 6, 0, 6] },
            ],
            [
              { text: 'Předsezóna', fontSize: 10, bold: true, color: C.red, margin: [0, 6, 0, 6] },
              { text: 'duben   ·   víkendy a teplé dny dle počasí 11:00 — 19:00', fontSize: 10, color: C.ink2, margin: [0, 6, 0, 6] },
            ],
            [
              { text: 'Posezóna', fontSize: 10, bold: true, color: C.red, margin: [0, 6, 0, 6] },
              { text: 'říjen   ·   víkendy a akce 11:00 — 19:00', fontSize: 10, color: C.ink2, margin: [0, 6, 0, 6] },
            ],
            [
              { text: 'Akce v lokalitě', fontSize: 10, bold: true, color: C.red, margin: [0, 6, 0, 6] },
              { text: 'rozšířený provoz dle dohody (sportovní akce, kulturní akce, slavnosti města)', fontSize: 10, color: C.ink2, margin: [0, 6, 0, 6] },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 12],
      },

      para('Pružnost provozu', { bold: true, color: C.ink, size: 11 }),
      bulletList([
        'Provozní dobu upravujeme dle aktuální návštěvnosti a počasí — v horkých dnech delší večerní provoz.',
        'V případě pořádaných akcí v areálu zajistíme prodloužený provoz po dohodě se zadavatelem.',
        'Přerušení provozu pouze v případě extrémních klimatických podmínek (vichřice, dlouhotrvající silný déšť) z bezpečnostních důvodů.',
        'Konkrétní harmonogram provozu bude v součinnosti s městem Otrokovice před zahájením každé sezóny finalizován.',
      ]),

      // ============================================================
      // ============ 05 — TOŽ TACOS PROPOJENÍ ======================
      // ============================================================
      ...sectionHeader('05', 'Značka Tož Tacos! — propojení', { pageBreak: 'before' }),
      {
        columns: [
          {
            width: '*',
            stack: [
              para(
                'Tož Tacos! je etablovaný streetfoodový brand kombinující autentickou mexickou kuchyni s českým gastronomickým know-how. Brand má vlastní vizuální identitu — sombrero, mexické barvy a hravý vizuál — který je atraktivní pro mladší cílovou skupinu, ale příjemný i pro rodiny s dětmi.'
              ),
              para('Klíčové znaky brandu Tož Tacos!', { bold: true, color: C.ink, size: 11 }),
              bulletList([
                'Autentická mexická kuchyně (tacos, quesadillas, burritos, nachos).',
                'Profesionální food truck s ikonickou tmavou polepkou.',
                'Vlastní receptury salsy, guacamole a marinád.',
                'Vlajka brandu — mexická zástava a temně barvený exteriér food trucku.',
                'Silný vizuální dojem a snadná zapamatovatelnost.',
              ]),
            ],
          },
          {
            width: 170,
            stack: [
              {
                table: {
                  widths: ['*'],
                  body: [[
                    {
                      stack: [
                        logoDataUrl
                          ? { image: logoDataUrl, width: 140, alignment: 'center', margin: [0, 12, 0, 12] }
                          : { text: 'TOŽ TACOS!', fontSize: 22, bold: true, color: C.red, alignment: 'center', margin: [0, 24, 0, 18] },
                        { text: 'TACOS · QUESADILLAS · BURRITOS', fontSize: 7, color: C.muted, characterSpacing: 2, alignment: 'center' },
                      ],
                      fillColor: C.white,
                      border: [true, true, true, true],
                      borderColor: [C.hair, C.hair, C.hair, C.hair],
                      margin: [10, 10, 10, 14],
                    },
                  ]],
                },
                layout: {
                  hLineWidth: () => 0.5,
                  vLineWidth: () => 0.5,
                  hLineColor: () => C.hair,
                  vLineColor: () => C.hair,
                },
              },
              {
                stack: [
                  { text: 'BRAND', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, margin: [0, 10, 0, 4] },
                  { text: 'Tož Tacos!', fontSize: 14, bold: true, color: C.ink },
                  { text: 'Provozováno společností', fontSize: 8, color: C.muted, margin: [0, 6, 0, 1] },
                  { text: META.client, fontSize: 10, bold: true, color: C.ink },
                ],
              },
            ],
          },
        ],
        columnGap: 18,
        margin: [0, 0, 0, 0],
      },

      // ============================================================
      // ============ 05 — FOOD TRUCK ===============================
      // ============================================================
      ...sectionHeader('06', 'Food truck a vizuál', { pageBreak: 'before' }),
      para(
        'Provoz na Štěrkovišti zajistíme pomocí profesionálního food trucku Tož Tacos! Jedná se o uzavřený přívěs s plně vybavenou kuchyní, výdejním okénkem a charakteristickým tmavým polepem s motivy sombrera, kaktusu a mexické vlajky.'
      ),

      // Hlavní fotka konceptu — food truck + tažný vůz Vše pro akci
      truckConceptDataUrl
        ? {
            stack: [
              { image: truckConceptDataUrl, width: 495, alignment: 'center', margin: [0, 0, 0, 6] },
              { text: 'Food truck Tož Tacos! připravený k převozu na Štěrkoviště — partnerství s Vše pro akci', fontSize: 8, italics: true, color: C.muted, alignment: 'center', margin: [0, 0, 0, 14] },
            ],
          }
        : {
            table: {
              widths: ['*'],
              body: [[{
                stack: [
                  { text: 'FOOD TRUCK · VIZUÁL', fontSize: 7, color: C.gold, characterSpacing: 3, bold: true, margin: [0, 0, 0, 6] },
                  { text: 'TOŽ TACOS!', fontSize: 30, bold: true, color: C.white, margin: [0, 0, 0, 4] },
                  { text: 'Tacos · Quesadillas · Burritos', fontSize: 10, color: '#cfc8b6', italics: true, margin: [0, 0, 0, 14] },
                ],
                fillColor: C.ink,
                border: [false, false, false, false],
                margin: [22, 30, 22, 30],
              }]],
            },
            layout: 'noBorders',
            margin: [0, 0, 0, 14],
          },

      // Druhá fotka — provoz s týmem
      truckOperationDataUrl
        ? {
            stack: [
              { image: truckOperationDataUrl, width: 495, alignment: 'center', margin: [0, 4, 0, 6] },
              { text: 'Food truck v běžném provozu — tým a charakteristický tmavý design s mexickými motivy', fontSize: 8, italics: true, color: C.muted, alignment: 'center', margin: [0, 0, 0, 14] },
            ],
          }
        : { text: '', margin: [0, 0, 0, 0] },

      // Třetí fotka — detail výdejního okénka s týmem a mexickou vlajkou
      truckDetailDataUrl
        ? {
            stack: [
              { image: truckDetailDataUrl, width: 495, alignment: 'center', margin: [0, 4, 0, 6] },
              { text: 'Detail výdejního okénka — tým Tož Tacos! při obsluze hostů, mexická vlajka jako vizuální prvek', fontSize: 8, italics: true, color: C.muted, alignment: 'center', margin: [0, 0, 0, 14] },
            ],
          }
        : { text: '', margin: [0, 0, 0, 0] },

      // truck specs
      para('Vybavení food trucku', { bold: true, color: C.ink, size: 11 }),
      {
        table: {
          widths: ['*', '*'],
          body: [
            [{ text: 'Plynový gril', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }, { text: 'Profesionální fritéza', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }],
            [{ text: 'Chladicí pult a mraznička', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }, { text: 'Pracovní plochy z nerezu', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }],
            [{ text: 'Výdejní okénko s pultem', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }, { text: 'Vlastní vodní hospodářství', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }],
            [{ text: 'Pokladní systém s tiskem účtenek', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }, { text: 'Platební terminál (karta, QR)', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }],
            [{ text: 'LED osvětlení interiéru i výdeje', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }, { text: 'Větrání a digestoř', fontSize: 9.5, color: C.ink2, margin: [0, 5, 0, 5] }],
          ],
        },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 12],
      },

      // ============================================================
      // ============ 06 — DŘEVĚNÝ MOBILIÁŘ =========================
      // ============================================================
      ...sectionHeader('07', 'Dřevěný mobiliář a posezení', { pageBreak: 'before' }),
      para(
        'Součástí naší nabídky je kompletní řešení venkovního posezení u food trucku. Pro Štěrkoviště jsme zvolili dřevěný mobiliář z masivu, který vizuálně i kvalitativně odpovídá charakteru rekreační lokality a vytváří příjemné prostředí pro pohodlnou konzumaci.'
      ),

      twoColCards([
        card('LAVICE S OPĚRADLY', [
          { text: 'Masivní dřevo s opěradly', fontSize: 11, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Pohodlné sezení dospělých i dětí. Robustní konstrukce odolná povětrnostním vlivům, ošetřeno proti vlhkosti a UV záření.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ]),
        card('STOLY Z MASIVU', [
          { text: 'Robustní jídelní stoly', fontSize: 11, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Plnohodnotné stoly z masivního dřeva, dostatečně velké pro skupinky 4 — 8 osob. Stabilita i v exteriéru.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.green),
        card('SLUNEČNÍKY', [
          { text: 'Kvalitní zástín', fontSize: 11, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Velkoformátové slunečníky nad každou sestavou stolu. Hosté si mohou pohodlně sednout i v plném slunci.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.gold),
        card('ESTETIKA', [
          { text: 'Soulad s lokalitou', fontSize: 11, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Přírodní dřevo působí teple a rekreačně — sednete si rád, vyjmete telefon nebo si jen vychutnáte jídlo a klidnou chvíli u vody.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.red),
      ]),
      para(
        'Mobiliář je součástí naší dodávky a po celou sezónu o něj pečujeme — udržujeme čistotu, pravidelně kontrolujeme stav a v případě potřeby doplňujeme.'
      ),

      // ============================================================
      // ============ 07 — MENU =====================================
      // ============================================================
      ...sectionHeader('08', 'Sortiment a menu', { pageBreak: 'before' }),
      para(
        'Sortiment je navržen tak, aby pokryl širokou škálu chutí a denních dob — od rychlé svačiny přes vydatný oběd po odpolední sladkou tečku. Všechna jídla jsou připravována čerstvě před hosty, převažují kuřecí, vepřové a vegetariánské varianty.'
      ),

      // Menu list
      ...TYPICAL_MENU.map((m, i) => menuRow(m, i)),

      { text: '', margin: [0, 8, 0, 0] },
      para('Nápoje a doplňky', { bold: true, color: C.ink, size: 11 }),
      bulletList(BEVERAGES, C.green),

      para('Cenová hladina a kvalita', { bold: true, color: C.ink, size: 11 }),
      para(
        'Ceny jsou kalibrovány tak, aby byly dostupné pro rodiny i pro mladou klientelu a zároveň odrážely vysokou kvalitu surovin. Hlavní jídla v rozsahu 120 — 220 Kč, nápoje 35 — 65 Kč. Konkrétní ceník bude finalizován před zahájením sezóny.'
      ),

      // ============================================================
      // ============ 09 — DOSAVADNÍ ZKUŠENOSTI =====================
      // ============================================================
      ...sectionHeader('09', 'Dosavadní zkušenosti s hostinskou činností', { pageBreak: 'before' }),
      para(
        'Tým Gourmet Crew s.r.o. a značka Tož Tacos! působí v oblasti mobilní gastronomie a streetfoodu několik sezón. Disponujeme zkušenostmi z různých typů lokalit — od rekreačních zón a sportovních areálů přes městské akce až po firemní eventy se stovkami hostů.'
      ),

      para('Typy lokalit a akcí, kde jsme již působili', { bold: true, color: C.ink, size: 11 }),
      twoColCards([
        card('REKREAČNÍ AREÁLY', [
          { text: 'Letní rekreační lokality, koupaliště a vodní plochy', fontSize: 10, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Zkušenost s každodenním sezónním provozem v lokalitách s vysokou koncentrací návštěvníků a rodinami s dětmi.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ]),
        card('SPORTOVNÍ AREÁLY', [
          { text: 'Sportovní akce a turnaje', fontSize: 10, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Zajištění občerstvení pro sportovní akce s nárazovou koncentrací osob — rychlý a efektivní výdej.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.green),
        card('FESTIVALY A KULTURNÍ AKCE', [
          { text: 'Hudební a kulturní akce', fontSize: 10, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Provoz na festivalech a městských slavnostech — průběžný výdej pro stovky až tisíce hostů.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.gold),
        card('FIREMNÍ EVENTY', [
          { text: 'Korporátní akce a teambuildingy', fontSize: 10, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
          { text: 'Catering a streetfoodový servis pro firemní akce velkých českých společností ve spolupráci s Vše pro akci s.r.o.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.red),
      ]),

      para('Provozní know-how', { bold: true, color: C.ink, size: 11 }),
      bulletList([
        'Pravidelný kontakt s hosty a obsluha v souladu s hygienickými standardy.',
        'Plné zaškolení personálu v HACCP a v provozu mobilní kuchyně.',
        'Zkušenost s denní logistikou (zásobování, skladování surovin, odvoz odpadů).',
        'Spolupráce s lokálními dodavateli a schopnost flexibilního rozšíření menu dle sezóny.',
        'Reference a doklady o jednotlivých realizacích k dispozici na vyžádání města Otrokovice.',
      ]),

      // ============================================================
      // ============ 10 — VŠE PRO AKCI =============================
      // ============================================================
      ...sectionHeader('10', 'Řešení špiček — partnerství s Vše pro akci', { pageBreak: 'before' }),
      para(
        'Štěrkoviště je rekreační lokalita s výraznými výkyvy návštěvnosti — od klidných všedních dnů po prudké letní víkendy, dny pořádaných akcí či sportovních turnajů. Pro zvládnutí těchto špiček máme uzavřené strategické partnerství s eventovou agenturou Vše pro akci s.r.o.'
      ),

      twoColCards([
        card('POSÍLENÍ PERSONÁLU', [
          { text: 'Dodatečné kuchařské a obslužné kapacity dostupné v řádu hodin — od víkendových sil až po sezónní eventy.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ]),
        card('CATERINGOVÁ EXPANZE', [
          { text: 'Pokud bude zájem města o catering pro významnou akci, jsme schopni rozšířit kapacitu o další výdejní místa, mobilní zázemí a obsluhu.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.green),
        card('TECHNICKÉ ZÁZEMÍ', [
          { text: 'Stany, mobiliář, chladicí kapacity, zástěny — kompletní eventové zázemí v případě potřeby větších akcí.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.gold),
        card('ZÁRUKA SPOLEHLIVOSTI', [
          { text: 'Vše pro akci je etablovaná zlínská agentura s rozsáhlými referencemi v eventovém průmyslu. Spolupráce je smluvně ošetřena.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45 },
        ], C.red),
      ]),
      para(
        'Toto partnerství je výraznou přidanou hodnotou naší nabídky — provoz na Štěrkovišti bude díky němu odolný i vůči mimořádným náporům a městu Otrokovice se nestane, že by v špičkové dny byla služba podkapacitovaná.'
      ),

      // ============================================================
      // ============ 09 — PLATEBNÍ MOŽNOSTI ========================
      // ============================================================
      ...sectionHeader('11', 'Platební možnosti', { pageBreak: 'before' }),
      para(
        'Pro maximální komfort hostů zajišťujeme všechny moderní platební metody. Plný EET / EVIDENČNÍ provoz, tisk účtenek na vyžádání, plně transparentní účetnictví.'
      ),

      {
        table: {
          widths: ['*', '*', '*'],
          body: [
            [
              {
                stack: [
                  { canvas: [{ type: 'rect', x: 0, y: 0, w: 30, h: 3, color: C.red }], margin: [0, 0, 0, 8] },
                  { text: 'HOTOVOST', fontSize: 8, bold: true, color: C.red, characterSpacing: 2, margin: [0, 0, 0, 4] },
                  { text: 'Klasická hotovostní platba', fontSize: 10.5, color: C.ink, bold: true, margin: [0, 0, 0, 4] },
                  { text: 'Drobné mince, bankovky, vrácení v rámci jedné měny.', fontSize: 9, color: C.ink2, lineHeight: 1.4 },
                ],
                fillColor: C.paper,
                border: [false, false, false, false],
                margin: [16, 16, 16, 16],
              },
              {
                stack: [
                  { canvas: [{ type: 'rect', x: 0, y: 0, w: 30, h: 3, color: C.green }], margin: [0, 0, 0, 8] },
                  { text: 'PLATEBNÍ KARTA', fontSize: 8, bold: true, color: C.green, characterSpacing: 2, margin: [0, 0, 0, 4] },
                  { text: 'Bezkontaktní terminál', fontSize: 10.5, color: C.ink, bold: true, margin: [0, 0, 0, 4] },
                  { text: 'Visa · MasterCard · Apple Pay · Google Pay. Bezkontaktní i čipové.', fontSize: 9, color: C.ink2, lineHeight: 1.4 },
                ],
                fillColor: C.paper,
                border: [false, false, false, false],
                margin: [16, 16, 16, 16],
              },
              {
                stack: [
                  { canvas: [{ type: 'rect', x: 0, y: 0, w: 30, h: 3, color: C.gold }], margin: [0, 0, 0, 8] },
                  { text: 'QR PLATBA', fontSize: 8, bold: true, color: C.red, characterSpacing: 2, margin: [0, 0, 0, 4] },
                  { text: 'QR kód · bankovní app', fontSize: 10.5, color: C.ink, bold: true, margin: [0, 0, 0, 4] },
                  { text: 'Vlastní QR pro každou platbu — bez čekání, bez papírových účtenek.', fontSize: 9, color: C.ink2, lineHeight: 1.4 },
                ],
                fillColor: C.paper,
                border: [false, false, false, false],
                margin: [16, 16, 16, 16],
              },
            ],
          ],
        },
        layout: { defaultBorder: false, paddingLeft: () => 0, paddingRight: (i) => (i < 2 ? 8 : 0), paddingTop: () => 0, paddingBottom: () => 0 },
        margin: [0, 0, 0, 16],
      },

      para('Účtenky a evidence', { bold: true, color: C.ink, size: 11 }),
      bulletList([
        'Tisk papírové účtenky na vyžádání hosta.',
        'Volitelné zaslání digitální účtenky e-mailem nebo přes QR.',
        'Plný EET / evidenční režim v souladu s českou legislativou.',
        'Měsíční reporty tržeb dostupné na vyžádání pro účely sledování provozu.',
      ]),

      // ============================================================
      // ============ 10 — NÁJEMNÉ A SHRNUTÍ ========================
      // ============================================================
      ...sectionHeader('12', 'Nabízené nájemné a shrnutí', { pageBreak: 'before' }),
      para(
        'Naše nabídka pro výběrové řízení města Otrokovice na provoz sezónního mobilního občerstvení na Štěrkovišti pro období 2026 — 2027:'
      ),

      {
        table: {
          widths: ['*'],
          body: [[
            {
              stack: [
                { text: 'NABÍZENÉ NÁJEMNÉ', fontSize: 8, color: C.gold, characterSpacing: 3, bold: true, margin: [0, 0, 0, 8] },
                { text: META.rent, fontSize: 48, bold: true, color: C.white, lineHeight: 0.95 },
                { text: META.rentVat, fontSize: 12, color: '#cfc8b6', italics: true, margin: [0, 4, 0, 14] },
                { canvas: [{ type: 'rect', x: 0, y: 0, w: 60, h: 2, color: C.gold }] },
                { text: 'za roční provoz mobilního občerstvení (0% sazba DPH)', fontSize: 9, color: '#cfc8b6', italics: true, margin: [0, 14, 0, 0] },
              ],
              fillColor: C.ink,
              border: [false, false, false, false],
              margin: [28, 26, 28, 26],
              alignment: 'center',
            },
          ]],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 18],
      },

      para('Co je v nabídce zahrnuto', { bold: true, color: C.ink, size: 11 }),
      bulletList([
        'Kompletní provoz food trucku Tož Tacos! včetně personálu a surovin.',
        'Dřevěný mobiliář z masivu (lavice s opěradly, stoly) a slunečníky.',
        'Hygienické zázemí v souladu s normami HACCP, povolení KHS, pojištění odpovědnosti.',
        'Garance řešení špiček díky partnerství s Vše pro akci s.r.o.',
        'Moderní platební možnosti (hotovost / karta / QR) a plný EET režim.',
        'Vlastní udržování mobiliáře a okolí food trucku po celou sezónu.',
        'Reportování tržeb a provozních dat na vyžádání města.',
      ]),

      para('Proč právě Gourmet Crew s.r.o.', { bold: true, color: C.ink, size: 11, margin: [0, 6, 0, 6] }),
      bulletList([
        'Známá, vizuálně silná značka Tož Tacos! přitahující návštěvníky všech věkových skupin.',
        'Profesionální provoz s tradicí v mobilním gastronomickém průmyslu.',
        'Bezpečnostní polštář v podobě eventového partnera Vše pro akci s.r.o.',
        'Estetické a kvalitní řešení posezení, které zapadne do rekreační lokality.',
        'Transparentní finanční nabídka a férové platební metody pro hosty.',
      ], C.green),

      // ============================================================
      // ============ 13 — ČESTNÉ PROHLÁŠENÍ UCHAZEČE ===============
      // ============================================================
      ...sectionHeader('13', 'Čestné prohlášení uchazeče', { pageBreak: 'before' }),
      para(
        'V souladu s podmínkami výběrového řízení města Otrokovice na provoz sezónního mobilního občerstvení na Štěrkovišti činí společnost Gourmet Crew s.r.o. následující čestné prohlášení:'
      ),

      // Boxed declaration
      {
        table: {
          widths: ['*'],
          body: [
            [{
              canvas: [{ type: 'rect', x: 0, y: 0, w: 240, h: 3, color: C.red }],
              border: [false, false, false, false],
            }],
            [{
              stack: [
                { text: 'PROHLÁŠENÍ', fontSize: 8, color: C.red, characterSpacing: 2, bold: true, margin: [0, 12, 0, 10] },
                {
                  text: [
                    { text: 'Společnost Gourmet Crew s.r.o.', bold: true, color: C.ink },
                    { text: ' (dále jen „uchazeč"), zastoupená jednatelem ', color: C.ink2 },
                    { text: 'Dušanem Horákem', bold: true, color: C.ink },
                    { text: ', tímto čestně prohlašuje, že:', color: C.ink2 },
                  ],
                  fontSize: 10.5,
                  lineHeight: 1.55,
                  margin: [0, 0, 0, 10],
                },
                {
                  ol: [
                    { text: 'nemá žádné dluhy ani neuhrazené závazky vůči městu Otrokovice ani vůči společnostem městem založeným či zřízeným organizacím;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'na majetek uchazeče není vyhlášen konkurz ani vedeno insolvenční řízení;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'uchazeč není v likvidaci;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'uchazeč nemá daňové nedoplatky vůči České republice;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'uchazeč nemá nedoplatky na pojistném a penále na veřejné zdravotní pojištění ani na sociální zabezpečení a příspěvku na státní politiku zaměstnanosti;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'uchazeč ani osoba oprávněná za něj jednat nebyla pravomocně odsouzena pro trestný čin, jehož skutková podstata souvisí s předmětem podnikání, ani pro trestný čin hospodářský nebo trestný čin proti majetku;', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                    { text: 'veškeré údaje uvedené v této nabídce jsou pravdivé, úplné a odpovídají skutečnosti.', fontSize: 10, color: C.ink2, lineHeight: 1.5, margin: [0, 0, 0, 6] },
                  ],
                  color: C.red,
                  margin: [0, 0, 0, 12],
                },
                {
                  text: 'Toto čestné prohlášení činím s vědomím právních důsledků uvedení nepravdivých údajů.',
                  fontSize: 10, italics: true, color: C.ink2, lineHeight: 1.5,
                  margin: [0, 0, 0, 20],
                },
                // Signature block
                {
                  table: {
                    widths: ['*', '*'],
                    body: [[
                      {
                        stack: [
                          { text: 'V Otrokovicích dne', fontSize: 8, color: C.muted, characterSpacing: 1, margin: [0, 0, 0, 6] },
                          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 0.6, lineColor: C.ink2 }], margin: [0, 14, 0, 6] },
                          { text: '[doplnit datum podání]', fontSize: 8, italics: true, color: C.muted },
                        ],
                        border: [false, false, false, false],
                        margin: [0, 0, 10, 0],
                      },
                      {
                        stack: [
                          { text: 'Podpis a razítko jednatele', fontSize: 8, color: C.muted, characterSpacing: 1, margin: [0, 0, 0, 6] },
                          { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 160, y2: 0, lineWidth: 0.6, lineColor: C.ink2 }], margin: [0, 14, 0, 6] },
                          { text: META.contactName + ', jednatel Gourmet Crew s.r.o.', fontSize: 8, italics: true, color: C.muted },
                        ],
                        border: [false, false, false, false],
                        margin: [10, 0, 0, 0],
                      },
                    ]],
                  },
                  layout: 'noBorders',
                },
              ],
              fillColor: C.paper,
              border: [false, false, false, false],
              margin: [22, 0, 22, 22],
            }],
          ],
        },
        layout: 'noBorders',
        margin: [0, 4, 0, 0],
      },

      // ============================================================
      // ============ 14 — PŘÍLOHY A DOKLADY ========================
      // ============================================================
      ...sectionHeader('14', 'Přílohy a doklady', { pageBreak: 'before' }),
      para(
        'K této nabídce předkládáme následující doklady a přílohy v souladu s požadavky výběrového řízení města Otrokovice:'
      ),

      {
        table: {
          widths: ['auto', '*'],
          body: [
            [
              { text: 'A', fontSize: 14, bold: true, color: C.red, border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair], margin: [0, 8, 14, 8] },
              { stack: [
                { text: 'Výpis z obchodního rejstříku', fontSize: 11, bold: true, color: C.ink, margin: [0, 8, 0, 2] },
                { text: 'Aktuálně platná kopie výpisu z obchodního rejstříku společnosti Gourmet Crew s.r.o. — přiloženo jako samostatný dokument k podání nabídky.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 8] },
              ], border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair] },
            ],
            [
              { text: 'B', fontSize: 14, bold: true, color: C.red, border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair], margin: [0, 8, 14, 8] },
              { stack: [
                { text: 'Živnostenský list — hostinská činnost', fontSize: 11, bold: true, color: C.ink, margin: [0, 8, 0, 2] },
                { text: 'Aktuální výpis ze živnostenského rejstříku potvrzující oprávnění k provozování hostinské činnosti — přiloženo jako samostatný dokument.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 8] },
              ], border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair] },
            ],
            [
              { text: 'C', fontSize: 14, bold: true, color: C.red, border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair], margin: [0, 8, 14, 8] },
              { stack: [
                { text: 'Čestné prohlášení uchazeče', fontSize: 11, bold: true, color: C.ink, margin: [0, 8, 0, 2] },
                { text: 'Podepsané čestné prohlášení o bezdlužnosti, insolvenci, likvidaci, daňových povinnostech, pojistném ZP/SP a trestní bezúhonnosti (sekce 13 této brožury).', fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 8] },
              ], border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair] },
            ],
            [
              { text: 'D', fontSize: 14, bold: true, color: C.red, border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair], margin: [0, 8, 14, 8] },
              { stack: [
                { text: 'Kontaktní údaje uchazeče', fontSize: 11, bold: true, color: C.ink, margin: [0, 8, 0, 2] },
                { text: 'Plné kontaktní údaje včetně sídla, telefonního a e-mailového spojení — uvedeny v sekci 15 (Závěr a kontakt).', fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 8] },
              ], border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair] },
            ],
            [
              { text: 'E', fontSize: 14, bold: true, color: C.red, border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair], margin: [0, 8, 14, 8] },
              { stack: [
                { text: 'Pojištění odpovědnosti za škodu', fontSize: 11, bold: true, color: C.ink, margin: [0, 8, 0, 2] },
                { text: 'Doklad o sjednaném pojištění odpovědnosti za škodu způsobenou provozem podnikatelské činnosti — k dispozici na vyžádání.', fontSize: 9.5, color: C.ink2, lineHeight: 1.45, margin: [0, 0, 0, 8] },
              ], border: [false, false, false, true], borderColor: [C.hair, C.hair, C.hair, C.hair] },
            ],
          ],
        },
        layout: {
          hLineColor: () => C.hair,
          hLineWidth: () => 0.5,
          vLineWidth: () => 0,
        },
        margin: [0, 0, 0, 14],
      },

      // Deadline reminder
      {
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: 'UZÁVĚRKA VÝBĚROVÉHO ŘÍZENÍ', fontSize: 8, color: C.gold, characterSpacing: 3, bold: true, margin: [0, 0, 0, 6] },
              { text: '15. 06. 2026  ·  11:00 hod.', fontSize: 16, bold: true, color: C.white },
            ],
            fillColor: C.ink,
            border: [false, false, false, false],
            margin: [22, 16, 22, 16],
            alignment: 'left',
          }]],
        },
        layout: 'noBorders',
        margin: [0, 6, 0, 0],
      },

      // ============================================================
      // ============ 15 — ZÁVĚR A KONTAKT ==========================
      // ============================================================
      ...sectionHeader('15', 'Závěr a kontakt', { pageBreak: 'before' }),
      para(
        'Vážení zástupci města Otrokovice, věříme, že naše nabídka představuje vyvážené řešení, které splňuje požadavky výběrového řízení a přináší přidanou hodnotu — atraktivní gastronomický koncept, kvalitní mobiliář a spolehlivého provozovatele se zázemím partnera pro špičky.'
      ),
      para(
        'Jsme připraveni k osobnímu jednání, návštěvě lokality i případnému doplnění této nabídky o další podklady — reference, vzorová menu, výrobní postupy či harmonogram provozu.'
      ),

      // Big contact card
      {
        table: {
          widths: ['*'],
          body: [
            [{
              canvas: [{ type: 'rect', x: 0, y: 0, w: 240, h: 3, color: C.red }],
              border: [false, false, false, false],
            }],
            [{
              stack: [
                { text: 'KONTAKTNÍ OSOBA', fontSize: 8, color: C.red, characterSpacing: 2, bold: true, margin: [0, 12, 0, 10] },
                { text: META.contactName, fontSize: 24, bold: true, color: C.ink, margin: [0, 0, 0, 4] },
                { text: META.contactRole, fontSize: 11, color: C.muted, margin: [0, 0, 0, 14] },
                {
                  table: {
                    widths: ['auto', '*'],
                    body: [
                      [
                        { text: 'TELEFON', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 6, 16, 0] },
                        { text: META.contactPhone, fontSize: 14, bold: true, color: C.ink, border: [false, false, false, false], margin: [0, 4, 0, 0] },
                      ],
                      [
                        { text: 'E-MAIL', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 10, 16, 0] },
                        { text: META.contactEmail, fontSize: 11, color: C.ink, border: [false, false, false, false], margin: [0, 8, 0, 0] },
                      ],
                      [
                        { text: 'SPOLEČNOST', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 10, 16, 0] },
                        { text: META.client, fontSize: 12, bold: true, color: C.ink, border: [false, false, false, false], margin: [0, 8, 0, 0] },
                      ],
                      [
                        { text: 'IČO', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 10, 16, 0] },
                        { text: META.ico, fontSize: 11, color: C.ink, border: [false, false, false, false], margin: [0, 8, 0, 0] },
                      ],
                      [
                        { text: 'ADRESA', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 10, 16, 0] },
                        { text: META.contactAddress, fontSize: 11, color: C.ink, border: [false, false, false, false], margin: [0, 8, 0, 0] },
                      ],
                      [
                        { text: 'BRAND', fontSize: 7, color: C.red, characterSpacing: 2, bold: true, border: [false, false, false, false], margin: [0, 10, 16, 0] },
                        { text: META.brand, fontSize: 12, bold: true, color: C.ink, border: [false, false, false, false], margin: [0, 8, 0, 0] },
                      ],
                    ],
                  },
                  layout: 'noBorders',
                },
              ],
              fillColor: C.paper,
              border: [false, false, false, false],
              margin: [22, 0, 22, 22],
            }],
          ],
        },
        layout: 'noBorders',
        margin: [0, 4, 0, 24],
      },

      // closing line
      {
        stack: [
          stripe(120),
          { text: 'Děkujeme za posouzení naší nabídky.', fontSize: 12, italics: true, color: C.ink, margin: [0, 18, 0, 4], alignment: 'center' },
          { text: '— Gourmet Crew s.r.o. & Tož Tacos! —', fontSize: 10, color: C.red, bold: true, margin: [0, 0, 0, 0], alignment: 'center' },
        ],
      },
    ],

    defaultStyle: {
      font: 'Roboto',
    },
  };
};

export default GourmetCrewOfferPage;
